import React from "react";
import PropTypes from "prop-types";
import { Card, Typography, Progress, Space } from "antd";

const { Title, Text } = Typography;

const StatCard = ({ title, amount, progress, status, color }) => {
  return (
    <Card style={{ borderRadius: 12, height: "100%" }}>
      <Space direction="vertical" size={4} style={{ width: "100%" }}>
        <Text type="secondary">{title}</Text>
        <Title level={3} style={{ margin: 0 }}>
          {amount}
        </Title>
        {typeof progress === "number" && (
          <Progress
            percent={progress}
            size="small"
            showInfo={false}
            strokeColor={color || "#1890ff"}
            style={{ marginTop: 8 }}
          />
        )}
        {status && (
          <Text type="secondary" style={{ fontSize: 12 }}>
            {status}
          </Text>
        )}
      </Space>
    </Card>
  );
};

StatCard.propTypes = {
  title: PropTypes.string.isRequired,
  amount: PropTypes.string.isRequired,
  progress: PropTypes.number,
  status: PropTypes.string,
  color: PropTypes.string,
};

export default StatCard;
